
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/testseries/aspire",
      function () {
        return require("private-next-pages/event/testseries/aspire.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/testseries/aspire"])
      });
    }
  